<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="基金代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['fundCode']"
            placeholder="请输入基金代码"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="基金名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['fundName']"
            placeholder="请输入基金名称"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="基金类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            type="list"
            v-decorator="['fundType']"
            :trigger-change="true"
            dictCode=""
            placeholder="请选择基金类型"
          />
        </a-form-item>
        <a-form-item
          label="基金状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            type="list"
            v-decorator="['fundStatus']"
            :trigger-change="true"
            dictCode=""
            placeholder="请选择基金状态"
          />
        </a-form-item>
        <a-form-item
          label="风险等级"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            type="list"
            v-decorator="['fundRisk']"
            :trigger-change="true"
            dictCode=""
            placeholder="请选择风险等级"
          />
        </a-form-item>
        <a-form-item
          label="起投金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['fundMinAmount']"
            placeholder="请输入起投金额"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="审核状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            type="list"
            v-decorator="['checked']"
            :trigger-change="true"
            dictCode=""
            placeholder="请选择审核状态"
          />
        </a-form-item>
        <a-form-item
          label="上架状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            type="list"
            v-decorator="['isdelete']"
            :trigger-change="true"
            dictCode=""
            placeholder="请选择上架状态"
          />
        </a-form-item>
        <a-form-item
          label="基金简称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['fundShortName']"
            placeholder="请输入基金简称"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="发行日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-date
            placeholder="请选择发行日期"
            v-decorator="['fundEmitdate']"
            :trigger-change="true"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';

export default {
  name: 'FundInfoModal',
  components: {
    JDate,
    JDictSelectTag
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/cn.aresoft.modules/fundInfo/add',
        edit: '/cn.aresoft.modules/fundInfo/edit'
      }
    };
  },
  created() {},
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'fundCode',
            'fundName',
            'fundType',
            'fundStatus',
            'fundRisk',
            'fundMinAmount',
            'checked',
            'isdelete',
            'fundShortName',
            'fundEmitdate'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'fundCode',
          'fundName',
          'fundType',
          'fundStatus',
          'fundRisk',
          'fundMinAmount',
          'checked',
          'isdelete',
          'fundShortName',
          'fundEmitdate'
        )
      );
    }
  }
};
</script>

<style lang="less" scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 30px;
  margin-bottom: 30px;
  float: right;
}
</style>
